module.exports = __webpack_public_path__ + "media/images/gallery/stories_off-fe8eedb492a81f53951fcc22e9763c27.gif";